module.exports = __webpack_public_path__ + "assets/ageRestrictionModalImg-d4c815.svg";